import { CreateSchemeMutationProvider } from "__legacy/queries/schemes/CreateSchemeMutationProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";

import { onError, onFinish, SchemeForm } from "./SchemeForm";

export const New: React.FC<{}> = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <CreateSchemeMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../")}>
      {(loading, mutate) => (
        <Fragment>
          <PageHeader
            ghost={true}
            title={`New Scheme`}
            extra={
              <Fragment>
                <Button onClick={() => navigate("../")}>Back to list</Button>
                <Button type="primary" loading={loading} onClick={() => form.submit()}>
                  Save
                </Button>
              </Fragment>
            }
          />
          <Layout.Content className="content">
            <SchemeForm action="create" form={form} handler={onFinish(mutate, {}, {})} values={{}} errors={errors} />
          </Layout.Content>
        </Fragment>
      )}
    </CreateSchemeMutationProvider>
  );
};
